import { AppLoading } from "@rdcs/dap-front-library";

export default AppLoading;
